import {
  pathOr,
  find,
  propEq,
  compose,
  set,
  lensProp,
  map,
  pipe,
  split,
  takeLast,
  splitAt,
  join,
  toLower,
  subtract,
  insert,
  length,
  head,
  lte,
  isEmpty,
  

} from 'ramda';
import { capitalize } from 'src/utilities/capitalize';
import currencyFormatter from 'currency-formatter';
import { TodoAny } from 'src/types';
/// A replica of letter_explanation_templates
//  The currently supported explanations and their named_fields
//  This will actually be sunset eventually since this is maintained in
//  letter_of_explanation_templates
//
export const GENERAL_UPLOAD = '0000_GENERAL_UPLOAD';
export const LOE_LARGE_DEPOSIT = '0001_BANK_STATEMENT_LARGE_DEPOSIT';
export const LOE_ADDRESS_CHANGE = '0002_CREDIT_REPORT_ADDRESS_CHANGE';
export const NAME_MISMATCH = '0005_NAME_MISMATCH';
export const ADDRESS_MISMATCH = '0003_ADDRESS_MISMATCH';
export const SSN_MISMATCH = '0006_SSN_CHANGE';


export const BUILTIN_EXPLANATIONS = () => {
  return [
    {
      template: LOE_LARGE_DEPOSIT,
      named_fields: [
        '0001_BANK_NAME',
        '0001_TRANSACTION_TYPE',
        '0001_AMOUNT',
        '0001_DATE',
        '0000_EXPLANATIONS',
      ], // This comes as part of the /letter_of_explnation_templates
    }, // I don't know this will work though
    {
      template: LOE_ADDRESS_CHANGE,
      named_fields: [
        '0002_ADDRESS',
        '0002_PERIOD_OF_STAY',
        '0002_SOURCE',
        '0002_DO_YOU_CURRENTLY_OWN_THIS_PROPERTY',
      ], // This comes as part of the /letter_of_explnation_templates
    },
    {
      template: NAME_MISMATCH,
      named_fields: [
        '0005_NAME_IN_THE_DOCUMENT_1',
        '0005_NAME_IN_THE_DOCUMENT_2',
        '0005_DOCUMENT_REFERRED_1',
        '0005_DOCUMENT_REFERRED_2',
        '0000_EXPLANATIONS',
      ], // This comes as part of the /letter_of_explnation_templates
    },
    {
      template: ADDRESS_MISMATCH,
      named_fields: [
        '0003_ADDRESS_1',
        '0003_ADDRESS_2',
        '0003_DOCUMENT_REFERRED_1',
        '0003_DOCUMENT_REFERRED_2',
        // '0003_PERIOD_OF_STAY',
        '0000_EXPLANATIONS',
      ], // This comes as part of the /letter_of_explnation_templates
    },
    {
      template: SSN_MISMATCH,
      named_fields: [
        '0006_SSN_IN_THE_DOCUMENT_1',
        '0006_SSN_IN_THE_DOCUMENT_2',
        '0006_DOCUMENT_REFERRED_1',
        '0006_DOCUMENT_REFERRED_2',
        '0006_EXPLANATIONS',
      ], // This comes as part of the /letter_of_explnation_templates
    },
    {
      template: GENERAL_UPLOAD,
      named_fields: ['0000_EXPLANATION_COMMENT'], // This comes as part of the /letter_of_explnation_templates
    },
  ];
};
// The built in explanation variables called named field, and the formatter to be applied.
// We call them named field since ever param is named like 0001_... etc.
// We anticiate 15-20 variables or else this list will be too heavy to manage.
const BUILTIN_EXPLANATIONS_MAPPED_FOR_USER_FACING = () => {
  return [
    {
      param: '0001_AMOUNT',
      shown_as: 'Amount',
      formatter: usdFormatter,
    },
    {
      param: '0001_DATE',
      shown_as: 'Transaction date',
      formatter: dateFieldFormatter,
    },
    {
      param: '0001_TRANSACTION_TYPE',
      shown_as: 'Transaction type',
      formatter: (tt: string) => (isEmpty(tt) ? 'Deposit' : capitalize(tt)),
    },
    {
      param: '0001_BANK_NAME',
      shown_as: 'Bank Name',
      formatter: stringFormatter,
    },
    {
      param: '0002_PERIOD_OF_STAY',
      shown_as: 'Period',
      formatter: stringFormatter,
    },
    { param: '0002_ADDRESS', shown_as: 'Address', formatter: stringFormatter },
    {
      param: '0005_NAME_IN_THE_DOCUMENT_1',
      shown_as: 'Name in the Document',
      formatter: stringFormatter,
    },
    {
      param: '0005_NAME_IN_THE_DOCUMENT_2',
      shown_as: 'Name in the Document',
      formatter: stringFormatter,
    },
    {
      param: '0005_DOCUMENT_REFERRED_1',
      shown_as: 'Name of the Document',
      formatter: stringFormatter,
    },
    {
      param: '0005_DOCUMENT_REFERRED_2',
      shown_as: 'Name of the Document',
      formatter: stringFormatter,
    },
    {
      param: '0003_ADDRESS_1',
      shown_as: 'Address in the document',
      formatter: stringFormatter,
    },
    {
      param: '0003_ADDRESS_2',
      shown_as: 'Address in the document',
      formatter: stringFormatter,
    },
    {
      param: '0003_DOCUMENT_REFERRED_1',
      shown_as: 'Address of the Document',
      formatter: stringFormatter,
    },
    {
      param: '0003_DOCUMENT_REFERRED_2',
      shown_as: 'Address of the Document',
      formatter: stringFormatter,
    },
    {
      param: '0003_PERIOD_OF_STAY',
      shown_as: 'Period',
      formatter: stringFormatter,
    },
    {
      param: '0006_SSN_IN_THE_DOCUMENT_1',
      shown_as: 'Social Security No',
      formatter: stringFormatter,
    },
    {
      param: '0006_SSN_IN_THE_DOCUMENT_2',
      shown_as: 'Social Security No',
      formatter: stringFormatter,
    },
    {
      param: '0006_DOCUMENT_REFERRED_1',
      shown_as: 'SSN of the Document',
      formatter: stringFormatter,
    },
    {
      param: '0006_DOCUMENT_REFERRED_2',
      shown_as: 'SSN of the Document',
      formatter: stringFormatter,
    },
    {
      param: '0000_EXPLANATIONS',
      shown_as: 'Description',
      formatter: stringFormatter,
    },
    {
      param: '0006_EXPLANATIONS',
      shown_as: 'Description',
      formatter: stringFormatter,
    },
    {
      param: '0000_EXPLANATION_COMMENT',
      shown_as: 'Description',
      formatter: stringFormatter,
    },
    {
      param: '0000_EXPLANATION_TITLE',
      shown_as: 'Description',
      formatter: stringFormatter,
    },
  ];
};
/// Every named field will have a formatter
// The formatters supported are
// 1. String Formatter (Default)  => does nothing, simply return the string
// 2. FixedField Formatter        => rounds of a number to the precision requested.
// 3. DateField Formatter         => converts a string to date format.
export const stringFormatter = (raw: TodoAny) => {
  return String(raw);
};
export const usdFormatter = (value: TodoAny) => {
  return currencyFormatter.format(parseInt(value, 10), {
    code: 'USD',
    precision: 0,
  });
};
const dateFieldFormatter = (raw: TodoAny) => {
  return raw;
};
// This is figures out for what should be explained by the user
// The 0001_BANK_STATEMENT_LARGE_DEPOSIT is pulled from
// asks.filled.template of an LOE
const shouldExplainWhat = (needed: TodoAny) => {
  return pathOr(
    [],
    ['named_fields'],
    find(propEq('template', needed))(BUILTIN_EXPLANATIONS())
  );
};
// Example call
// efx("0001_BANK_STATEMENT_LARGE_DEPOSIT");
// Once the named_fields for a template is figured out, we stick the named
// values for the fields as seen in the LOE.
export const efx = (template: string, namedValues: TodoAny) => {
  return compose(
    (namedFields: any) => stickValuesToUserFacingVars(namedFields, namedValues),
    shouldExplainWhat
  )(template);
};
// efxTable
// efxTable(efx("0001_BANK_STATEMENT_LARGE_DEPOSIT"));
// Forms table conent of LOE pdf template from efx response data
// Form each field shown_as will be column head and formatter as column value
// If there is more than 5 fields from table field as vertical row
// Common headers Fields and values
// each shown_as and formatter will be row values respectively
const MAX_TABLE_COL_SPAN = 100;
const MAX_NO_COL_IN = 5;
export const efxTable = (fields: any) => {
  if (compose(lte(MAX_NO_COL_IN), length)(fields)) {
    return verticalTable(fields);
  } else {
    return horizontalTable(fields);
  }
};
export const horizontalTable = (fields: any) => {
  const numberOfCols = length(fields);
  const subsequentCol = Math.round(MAX_TABLE_COL_SPAN / numberOfCols);
  const firstCol = subtract(
    MAX_TABLE_COL_SPAN,
    subtract(numberOfCols, 1) * subsequentCol
  );
  const [firstField, subsequentFields] = splitAt(1, fields);
  let heads = subsequentFields.map((f: any) => {
    return {
      name: pathOr('', ['shown_as'], f),
      colSpanPercent: `${subsequentCol}%`,
    };
  });
  heads = insert(0, {
    name: pathOr('', ['shown_as'], head(firstField)),
    colSpanPercent: `${firstCol}%`,
  })(heads);
  const columnValues = fields.map((f: any, _index: number) => {
    return {
      value: pathOr('', ['formatted'], f),
    };
  });
  return {
    heads,
    rowColumns: [
      {
        columnValues,
      },
    ],
  };
};
export const verticalTable = (fields: any) => {
  const heads = [
    {
      name: 'Fields',
      colSpanPercent: `60%`,
    },
    {
      name: 'Values',
      colSpanPercent: `40%`,
    },
  ];
  const rowColumns = fields.map((f: any, _index: number) => {
    return {
      columnValues: [
        {
          value: pathOr('', ['shown_as'], f),
        },
        {
          value: pathOr('', ['formatted'], f),
        },
      ],
    };
  });
  return {
    heads,
    rowColumns,
  };
};
/// This takes the named_fields and its corresponding named values in an LOE and
//  applied the formatter function to it.
const stickValuesToUserFacingVars = (
  namedFields: TodoAny,
  namedValues: TodoAny
) => {
  const applyFormatter = (x: TodoAny) => {
    const param = pathOr('', ['param'])(x);
    const formatter = pathOr(
      (_t: any) => {
        /* empty func */
      },
      ['formatter']
    )(x);
    return formatter(pathOr('', ['asks', 'filled', param])(namedValues));
  };
  return pipe(
    map(parmsForUserReadability),
    map((parmsObj) => {
      // @ts-ignore
      return set(lensProp('formatted'), applyFormatter(parmsObj), parmsObj);
    })
  )(namedFields);
};
///
const parmsForUserReadability = (param: TodoAny) => {
  return find(propEq('param', param))(
    BUILTIN_EXPLANATIONS_MAPPED_FOR_USER_FACING()
  );
};
/// A handy function that take the explanation template naming and provides
//  title.
//  Example
//  (0001_BANK_STATEMENT_LARGE_DEPOSIT, offset=1) => produces "Deposit"
//  (0002_CREDIT_REPORT_ADDRESS_CHANGE, offset=2) => produces "Address Change"
export const scrubReadableTitle = (
  crudeTitle: string,
  rightOffsetPos: number
) => {
  return pipe(
    split('_'),
    // @ts-ignore
    takeLast(rightOffsetPos),
    map(toLower),
    map(capitalize),
    join(' ')
    //@ts-ignore
  )(crudeTitle);
};

